import ApiServiceV6Core from '@/helpers/api.service.v6core';
const APIV6Core = new ApiServiceV6Core();


export const state = {
   
}

export const mutations = {
    
}

export const actions = {
    actionCoreEloadProviderAPIPOST(_, {params, action}) {
        return new Promise((resolve, reject) => {
            // console.log("actionCoreEloadProviderAPIPOST params:", params);
            // Use normal API service (with preloader)
            APIV6Core.post(`/eload/provider/${action}`, params)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                if (error.response && error.response.data) {
                    resolve(error.response.data);
                } else {
                    reject(error);
                }
            });
        });
    },
}

export const getters = {
    
}